import { Tag } from 'antd';
import ModalCloseIcon from '../Icons/ModalCloseIcon';

export default function TagsRender(props) {
  const { label, value, closable, onClose } = props;
  const onPreventMouseDown = event => {
    event.preventDefault();
    event.stopPropagation();
  };
  return (
    <Tag
      color={value}
      onMouseDown={onPreventMouseDown}
      closable={closable}
      onClose={e => {
        e.preventDefault();
        onClose(label);
      }}
      className={'custom-tags'}
      closeIcon={<ModalCloseIcon height="14" width="14" />}
      key={label}
    >
      {label}
    </Tag>
  );
}
